import React, { useState } from "react";
import { Grid } from "@mui/material";
import { BannerSearchListResponseDataItem } from "../../../../api/content-client/service";
import { BannerWidget } from "../../../widgets/BannerWidget/BannerWidget";

type Props = {
  banners: BannerSearchListResponseDataItem[];
  currentPage: number;
  position: number;
};

const gridItemWidthLgBy: Record<'one' | 'two' | 'four', number> = {
  one: 3,
  two: 6,
  four: 12,
}

const gridItemWidthMdBy: Record<'one' | 'two' | 'four', number> = {
  one: 4,
  two: 8,
  four: 12,
};

const gridItemWidthSmBy: Record<'one' | 'two' | 'four', number> = {
  one: 6,
  two: 12,
  four: 12,
};

export const BannersSearch = (props: Props) => {
  const { banners, currentPage, position } = props;
  const [isRaised, setRaised] = useState(false);

  if (!banners?.length) {
    return null;
  }

  const foundBanner = banners.find(banner => (
    banner.attributes?.page === currentPage
    && banner.attributes?.position === position
  ))

  return foundBanner ? (
      <Grid
        onMouseEnter={() => setRaised(true)}
        onMouseLeave={() => setRaised(false)}
        onTouchStart={() => setRaised(true)}
        item
        xs={12}
        sm={gridItemWidthSmBy[foundBanner.attributes?.size || "one"]}
        md={gridItemWidthMdBy[foundBanner.attributes?.size || "one"]}
        lg={gridItemWidthLgBy[foundBanner.attributes?.size || "one"]}
        sx={{
          transition: "all .1s ease-in",
          transform: isRaised ? "translateY(-1%)" : undefined,
        }}
      >
        <BannerWidget
          linkUrl={foundBanner.attributes?.linkUrl ?? ''}
          {...foundBanner.attributes}
          containerSx={{
            minHeight: 296,
          }}
        />
      </Grid>
    ) : null;
};
